angular.module('gym.invoices').controller('DenyFailedPaymentRetryCtrl', ["$scope", "$modalInstance", function($scope, $modalInstance) {
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
